export const MENU_IMAGE_ACCEPT = 'image/jpeg,image/png,image/webp,image/avif,.avif';
export const MENU_IMAGE_ERROR = 'Choose a JPEG, PNG, WebP or AVIF image smaller than 5 MB.';

export function isMenuImage(file) {
  if (!file || file.size > 5 * 1024 * 1024) return false;
  if (['image/jpeg', 'image/png', 'image/webp', 'image/avif'].includes(file.type)) return true;
  // Some file pickers don't assign a MIME type to AVIF. The backend always
  // checks the actual image contents before accepting or converting the file.
  return ['', 'application/octet-stream'].includes(file.type) && /\.(jpe?g|png|webp|avif)$/i.test(file.name);
}
